import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import * as ReactDOM from 'react-dom';
import { isMobile } from 'react-device-detect';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { vehicleRegistryColumns } from './settings';
import Pagination from '../../../components/base/Pagination/Pagination';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { getVehicleRegistryData } from '../reducer';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../utils/utils';
import { VEHICLES_REGISTRY_MODULE } from '../../../configs/moduleNames';
import { loadVehicleRegistryList } from '../actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import { getSystemData } from '../../System/reducer';
import VehicleFilterRow from './VehicleFilterRow';
import Loader from '../../../components/base/Loader/Loader';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';
import MobileVehicleFooter from './MobileVehicleFooter';

export default function VehiclesGrid(props) {
  const {
    handleOpenDetails = () => {},
    handleShowHistory = () => {},
  } = props;
  const blockRef = useRef(null);
  const {
    vehicleRegistryList,
    loadingVehicleRegistryList,
    vehicleRegistryListMeta,
  } = useSelector(getVehicleRegistryData);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const store = useStore();
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);

  const filterName = 'vehicle-registry-filter';
  const defaultFilterValues = {};
  const {
    getValues, watch, control, reset, setValue,
  } = useForm({ defaultValues: getFilterData(filterName, defaultFilterValues) });
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VEHICLES_REGISTRY_MODULE].vehicleRegistryListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadVehicleRegistryList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  const [sort, setSort] = useState(getDefaultSort(vehicleRegistryColumns));
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => { loadData(); }, [sort]);

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={() => handleOpenDetails(item)}>
        Посмотреть
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={() => handleShowHistory(item)}>
        История поездок
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileVehicleFooter
      control={control}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      page={PAGE_TYPE.VEHICLE_REGISTRY}
    />, element);
  };

  return (
    <>
      {!isMobile ? (
        <VehicleFilterRow
          selectedTab={1}
          toggleFilter={() => setOpenFilter(!isOpenFilter)}
          control={control}
        />
      ) : null}
      <div className="page-content-wrapper">
        <Loader global loading={loadingVehicleRegistryList} />
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  data={vehicleRegistryList}
                  columns={vehicleRegistryColumns}
                  name="vehicle-registry-list"
                  loading={loadingVehicleRegistryList}
                  additionalColumns={[]}
                  changeSort={changeSort}
                  sort={sort}
                  onDoubleClickByRow={handleOpenDetails}
                  settingsFormatter={moreFormatter}
                  renderContextMenu={renderContextMenu}
                  rowClassFormatter={item => 'clickable-table-row'}
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              data={vehicleRegistryList}
              columns={vehicleRegistryColumns}
              name="vehicle-registry-list"
              loading={loadingVehicleRegistryList}
              additionalColumns={[]}
              onDoubleClickByRow={handleOpenDetails}
              settingsFormatter={moreFormatter}
              renderContextMenu={renderContextMenu}
              rowClassFormatter={item => 'clickable-table-row'}
            />
          )}
          <Pagination meta={vehicleRegistryListMeta} list={vehicleRegistryList} handleChangeMeta={loadData} />
        </div>
        {isOpenFilter
          ? (
            <FilterModal
              control={control}
              onClose={() => setOpenFilter(false)}
              getValues={getValues}
              reset={reset}
              defaultValues={defaultFilterValues}
              page={PAGE_TYPE.VEHICLE_REGISTRY}
            />
          )
          : null}
      </div>
      {isMobile ? renderFooter() : null}
    </>
  );
}
